import MeetingNotesContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/MeetingNotesContent";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";

export default class TeaCornerContent {
    /**
     * @constructor
     * @param {MeetingNotesContent} content
     */
    constructor(content) {
        this._content = content;
    }

    get content() {
        return this._content;
    }

    toObject() {
        return {
            content: this._content.convertToObject()
        };
    }

    fromObject(obj, languagePack) {
        this._content = meetingNotesContentObject(obj.content, languagePack);
    }
}

const meetingNotesContentObject = function (obj, languagePack) {
    const meetingNotesContent = new MeetingNotesContent(languagePack, null, null);
    meetingNotesContent.setPropertiesFromObject(obj);
    return meetingNotesContent;
}